import { IGrpStandardPageConfig } from "../../../shared/interfaces/IPageConfig";
import { IZones } from "../../../shared/interfaces/IZones";

export const Config: IGrpStandardPageConfig<IZones> = {
    api: { path: "zoning" },
    fields: {
        id: {
            label: "Id",
            fieldType: "number",
        },
        zonas_tipo: {
            label: "Nome Zona, Eixo ou Setor",
            fieldType: "text",
        },
        zonas_codigo: {
            label: "Sigla",
            fieldType: "text",
        },
        zonas_descricao: {
            label: "Descrição (Características predominantes)",
            fieldType: "text",
        },
        zonas_leis_permitidas: {
            label: "Leis Permitidas",
            fieldType: "text",
        },
        zonas_leis_permissivas: {
            label: "Leis Permissivas",
            fieldType: "text",
        },
        zonas_leis_proibidas: {
            label: "Leis Proibidas",
            fieldType: "text",
        },
        zonas_cnaes_permitidos: {
            label: "CNAEs Permitidos",
            fieldType: "text",
        },
    },
};
